
import { Outlet } from "react-router-dom";
import WebsiteHeader from "./WebsiteHeader";
import Footer from "./Footer";

const WebsiteLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <WebsiteHeader />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default WebsiteLayout;
